/* ═══════════════════════════════════════════════════════════════
   STATIC NAVIGATION DATA — v2 (per "KKB Corrections" handwritten notes)

   Changes from v1:
   1. Printed Lungi split → "Rotary Mill Printed Lungi" + "Local Print Lungi"
   2. Dhothi promoted to its own top-level nav item (was inside Lungies)
   3. Dhorth moved from Lungies → Towel
   4. Kerchief promoted to its own top-level nav item (was inside Hometextiles)
   5. Tissue Shirt (T-Shirt) given 3 colour variants
   6. Jambura promoted to its own top-level nav item (was folded into
      Lungies/Bedsheets/Towel/Hometextiles), placed right after Hometextiles,
      organized into 6 groups: Shirt, Towel, Kerchief, Bedspread, Dhothi, Kaavi
═══════════════════════════════════════════════════════════════ */

const slugify = (s) =>
  s
    .toLowerCase()
    .replace(/[()]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

const link = (label, opts = {}) => ({
  label,
  slug: slugify(label),
  isNew: !!opts.isNew,
  isHot: !!opts.isHot,
});

const navItems = [
  /* ─────────────────────────── HOME TEXTILES ─────────────────────────── */
  /* ─────────────────────────── HOME TEXTILES ─────────────────────────── */
  {
    label: "Hometextiles",
    path: "/collection",
    state: { category: "Hometextiles" },
    mega: true,
    cols: [
      {
        title: "Bed Linen",
        links: [
          link("200TC"),
          link("250TC"),
          link("300TC"),
          link("400TC"),
          link("Pillow Covers"),
        ],
      },
      {
        title: "Bath Linen",
        links: [
          link("Bath Towels"),
          link("Hand Towels"),
          link("Face Towels"),
          link("Pool Towels"),
          link("Spa Towels"),
          link("Bath Mates"),
        ],
      },
      {
        title: "Accessories",
        links: [
          link("Duvet - 250 Gsm Micro Polyester Fabric"),
          link("Duvet - 300 Gsm Micro Polyester Fabric"),
          link("Soft Pillows"),
          link("Mattress Protectors"),
          link("Bed Runners"),
          link("Cushions"),
          link("Blankets"),
          link("Pillow Protector"),
          link("Hard Pillows"),
        ],
      },
      {
        title: "Hospital Bedsheets",
        links: [
          link("Hospital Bedsheets & Pillow Covers"),
          link("Hospital Polycotton Stripe Embossed Bedsheet"),
        ],
      },
      {
        title: "Bath Mat",
        links: [
          link("20*30 - Bath Mat"),
          link("300grm - Bath Mat"),
          link("Terry Washed - Bath Mat"),
          link("Checked Type - Bath Mat (White Color Available)"),
        ],
      },
      {
        title: "Mattress Protector",
        links: [link("Quilted Mattress Protector")],
      },
    ],
  },

  /* ─────────────────────────── JAMBURA (NEW, standalone — placed
         right after Hometextiles per note "Near New Home Textile Navbar") ─────────────────────────── */
  {
    label: "Jambura",
    path: "/collection",
    state: { category: "Jambura" },
    mega: true,
    cols: [
      {
        title: "Jambura Shirt",
        links: [
          link("Jambura Classic (Half)", { isNew: true }),
          link("Jambura Classic (Full)", { isNew: true }),
          link("Jambura Trendy (Half)", { isNew: true }),
          link("Jambura Trendy (Full)", { isNew: true }),
          link("Jambura Premium Full (36-44)", { isNew: true }),
          link("Jambura Premium Full-46", { isNew: true }),
          link("Jambura Premium Full-48", { isNew: true }),
          link("Jambura Premium Full-50", { isNew: true }),
          link("Jambura Premium Half (36-44)", { isNew: true }),
          link("Jambura Premium Half-46", { isNew: true }),
          link("Jambura Premium Half-48", { isNew: true }),
          link("Jambura Premium Half-50", { isNew: true }),
          link("Jambura Grand Half (38-44)", { isNew: true }),
          link("Jambura Grand Full (38-44)", { isNew: true }),
        ],
      },
      {
        title: "Jambura Towel",
        links: [
          link("Jambura White Floral (30X60)", { isNew: true }),
          link("Jambura White Floral (33X66)", { isNew: true }),
          link("Jambura Soft Touch (22X44)", { isNew: true }),
          link("Jambura Soft Touch (24X48)", { isNew: true }),
          link("Jambura Soft Touch (26X52)", { isNew: true }),
          link("Jambura Soft Touch (28X56)", { isNew: true }),
          link("Jambura Soft Touch (30X60)", { isNew: true }),
          link("Jambura Terry Towel 450GRM (27X54)", { isNew: true }),
        ],
      },
      {
        title: "Jambura Kerchief",
        links: [
          link("Jambura Milky White Kerchief (Pack of 6)", { isNew: true }),
          link("Jambura Bright White Kerchief (Pack of 3)", { isNew: true }),
        ],
      },
      {
        title: "Jambura Bedspread",
        links: [
          link("Jambura Bed Spread Single (2/6)", { isNew: true }),
          link("Jambura Bed Spread Double (2/7)", { isNew: true }),
          link("Jambura Bed Spread Family (2/9)", { isNew: true }),
        ],
      },
      {
        title: "Jambura Dhothi",
        links: [
          link("Jambura SB Dhothi", { isNew: true }),
          link("Jambura BB Dhothi", { isNew: true }),
          link("Jambura 1/2 Gold Dhothi", { isNew: true }),
        ],
      },
      {
        title: "Jambura Kaavi",
        links: [link("Jambura Kaavi Set", { isNew: true })],
      },
    ],
  },
  /* ─────────────────────────── LUNGIES ─────────────────────────── */
  {
    label: "Lungies",
    path: "/collection",
    state: { category: "Lungies" },
    mega: true,
    cols: [
      {
        title: "Rotary Mill Printed Lungi",
        links: [
          link("Elantra (Box) 2.00MTR"),
          link("Elantra 2.25MTR"),
          link("Elantra 2.50MTR"),
          link("Vindhya 2.00MTR"),
          link("Vindhya 2.25MTR"),
          link("Vindhya 2.50MTR"),
          link("GoldenTouch 2.00MTR"),
          link("GoldenTouch 2.25MTR"),
          link("GoldenTouch 2.50MTR"),
          link("Anupama 2.00MTR"),
          link("Anupama 2.25MTR"),
          link("Anupama 2.50MTR"),
          link("Lancer 2.00MTR"),
          link("Lancer 2.25MTR"),
          link("Lancer 2.50MTR"),
          link("Metro 2.00MTR"),
          link("Metro 2.25MTR"),
          link("Metro 2.50MTR"),
          link("Imperial 2.10"),
          link("Mangalya White 2.00MTR"),
          link("Mangalya White 2.25MTR"),
          link("Anupama 10MTR"),
          link("Lancer 10MTR"),
          link("Metro 10MTR"),
          link("Vindhya 10MTR"),
        ],
      },
      {
        title: "Local Print Lungi",
        links: [
          link("Abilash 2.00MTR"),
          link("Abilash 2.25MTR"),
          link("City 2.00MTR"),
          link("City 2.25MTR"),
        ],
      },
      {
        title: "Checked Lungi",
        links: [
          link("Tendulkar 2.00"),
          link("Tendulkar 2.10"),
          link("Tendulkar 2.25"),
          link("Tendulkar 2.50"),
          link("Kabali 2.00"),
          link("Kabali 2.10"),
          link("Kabali 2.25"),
          link("Sheela 2.00"),
          link("Sheela 2.10"),
          link("VIRAT 2.00"),
          link("VIRAT 2.10"),
          link("VIRAT 2.25"),
          link("KHAN 2.10"),
          link("SAMSON 2.10"),
          link("Skylard 2.00"),
          link("Skylard 2.25"),
          link("Skylard 2.50"),
          link("Prem 2.00"),
          link("Prem 2.25"),
          link("Prem 2.50"),
          link("Prem White Check 2.00"),
        ],
      },
    ],
  },

  /* ─────────────────────────── BEDSHEETS ─────────────────────────── */
  {
    label: "Bedsheets",
    path: "/collection",
    state: { category: "Bedsheets" },
    mega: true,
    cols: [
      {
        title: "Bed Spread",
        links: [
          link("Caliber 60X90 (Single)"),
          link("Caliber 70X90 (Double)"),
          link("Caliber 90X100 (Family)"),
          link("Caliber 2/6 (Single)"),
          link("Caliber 2/7 (Double)"),
          link("Caliber 2/9 (Family)"),
          link("Diamond 60X90 (Single)"),
          link("Diamond 70X90 (Double)"),
          link("Diamond 90X100 (Family)"),
          link("Diamond 2/6 (Single)"),
          link("Diamond 2/7 (Double)"),
          link("Diamond 2/9 (Family)"),
          link("Imperial 60X90 (Single)"),
          link("Imperial 70X90 (Double)"),
          link("Imperial 90X100 (Family)"),
          link("Imperial 2/6 (Single)"),
          link("Imperial 2/7 (Double)"),
          link("Imperial 2/9 (Family)"),
        ],
      },
      {
        title: "CMBS",
        links: [link("CM BS-2"), link("CM BS-31")],
      },
    ],
  },

  /* ─────────────────────────── TOWEL ─────────────────────────── */
  {
    label: "Towel",
    path: "/collection",
    state: { category: "Towel" },
    mega: true,
    cols: [
      {
        title: "Towels",
        links: [
          link("Aradhana (30X60)"),
          link("Cool Cotton Colour (30X60)"),
          link("Cool Cotton White (30X60)"),
          link("Pepsi (27X54)"),
          link("Regency (30X60)"),
          link("Regency (33X66)"),
          link("Chancellor (30X60)"),
          link("Chancellor (33X66)"),
          link("Simphony3 (30X60)"),
          link("Special Rose (30X60)"),
          link("Special Sagar (30X60)"),
          link("Special Ellora (30X60)"),
          link("Special Vijay (30X60)"),
        ],
      },
      {
        title: "Lunch Towel",
        links: [
          link("Napkin 1 (15X25)"),
          link("Napkin 2 (15X25)"),
          link("Napkin 3 (15X25)"),
          link("Napkin 4 (15X25)"),
          link("Napkin 5 (15X25)"),
          link("Napkin 6 (15X25)"),
        ],
      },
      {
        title: "Dhorth",
        links: [
          link("Dhorth White 22X44"),
          link("Dhorth White 24X48"),
          link("Dhorth White 26X52"),
          link("Dhorth White 28X64"),
          link("Dhorth White 30X60"),
          link("Dhorth Col. Plain 22X44"),
          link("Dhorth Col. Plain 26X52"),
          link("Dhorth Col. Plain 30X60"),
          link("Dhorth Col. Check 22X44"),
          link("Dhorth Col. Check 26X52"),
          link("Dhorth Col. Check 30X60"),
        ],
      },
    ],
  },

  /* ─────────────────────────── KERCHIEF (NEW, standalone) ─────────────────────────── */
  {
    label: "Kerchief",
    path: "/collection",
    state: { category: "Kerchief" },
    mega: true,
    cols: [
      {
        title: "Kerchief",
        links: [
          link("Milky White 12in1 (Pack of 3)"),
          link("Brighte White 12in1 (Pack of 3)"),
          link("Colour Plain 1"),
          link("Colour Plain 2"),
          link("Colour Plain 3"),
          link("Colour Check 1"),
          link("Colour Check 2"),
          link("Colour Check 3"),
        ],
      },
    ],
  },

  /* ─────────────────────────── KAAVI ─────────────────────────── */
  {
    label: "Kaavi",
    path: "/collection",
    state: { category: "Kaavi" },
    mega: true,
    cols: [
      {
        title: "Kaavi",
        links: [
          link("Kaavi Mamooty"),
          link("Kaavi Perthiv"),
          link("Kaavi Rasi", { isHot: true }),
          link("Kaavi Mershal"),
          link("Kaavi Kaala (Black & White)"),
          link("Kaavi Biju"),
          link("Black Iyyappa"),
          link("Kaavi Pentex"),
          link("Kaaviui Rubee"),
        ],
      },
    ],
  },

  /* ─────────────────────────── DHOTHI (NEW, standalone) ─────────────────────────── */
  {
    label: "Dhothi",
    path: "/collection",
    state: { category: "Dhothi" },
    mega: true,
    cols: [
      {
        title: "Dhothi",
        links: [
          link("Nigil SB"),
          link("Pavin BB"),
          link("TCM Colour Dhothi"),
          link('1/2" Surya Gold'),
          link("Prithiv Silver"),
          link("LST Fancy (Matching Set)"),
          link("KLT Fancy Mix"),
          link("KLT Gold Single"),
          link("KL SB"),
          link("Gill BB"),
          link("9x5 Dhothi"),
          link("Pooja Set White"),
          link("Pooja Set Colour"),
        ],
      },
    ],
  },
];

export default navItems;
